import {Confirm} from './confirm/index';
import {Toast} from './toast/index';

const Dialog = {};

Dialog.install = function install(Vue) {
  Vue.prototype.$dialog = {
    Confirm,
    Toast
  };
};

export default Dialog;



// WEBPACK FOOTER //
// ./src/components/Dialog/index.js